import { render, staticRenderFns } from "./McpConsent.vue?vue&type=template&id=2dae9b69"
import script from "./McpConsent.vue?vue&type=script&lang=js"
export * from "./McpConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports